import {RiDeleteBin5Line} from "react-icons/ri";
import React from "react";
import mapping from "../../../config/mapping";
import FilterSubItem from "../FilterSubItem/FilterSubItem";


const FilterItem = ({

                        item,
                        clearFilters = () => {
                        },
                        selectedOptions,
                        isExpanded,
                        toggleSubCategoryExpansion,
                        toggleCategoryExpansion,
                        expandedSubCategories,
                        handleFilterOptionChange,
                        handleRadioFilterOptionChange,
                        toggleCategorySelection,
                        isCheckboxVisible,
                        isFromListing,
                        lang,
                        isAvailabilityFilterSelected
                    }) => {

    const isAvailabilityCategory =
        item?.title?.toLowerCase() === "available" ||
        item?.title?.toLowerCase() === "διαθέσιμα";

    const availabilityItems = [
        {
            ...item.items.find(x => x.title === "inStock"),
            displayTitle: lang === "en" ? "Yes" : "Ναι",
            aggregate:
                (item.items.find(x => x.title === "inStock")?.aggregate ?? 0) +
                (item.items.find(x => x.title === "lowStock")?.aggregate ?? 0),
            includeKeys: ["inStock", "lowStock"]
        }
    ];

    if(isAvailabilityCategory) {
        selectedOptions[item.categoryId]?.some(entry =>
            entry.originalKeys
                ? entry.originalKeys.includes(entry.category)
                : entry.category === entry.title
        )
    }

    const yesNoFromTitle = (title) => {

        if(title === '0') {
            return lang === "en" ? "No" : "Όχι";
        } else if(title === '1'){
            return lang === "en" ? "Yes" : "Ναι";
        }
        return title;
    };

    return (

        <div aria-labelledby={item?.title}>
            <div className="category-title">
                <span>
                    {item?.title}
                    {(selectedOptions[item.categoryId]?.length > 0 && isFromListing===false) && (
                        <RiDeleteBin5Line
                            className="clear-filter-button"
                            onClick={() => clearFilters(item.categoryId)}
                            style={{marginLeft: '10px'}}
                            size={20}
                        />
                    )}
                </span>
            </div>
            <ul className="filter-items-list"
                style={{
                    maxHeight: (isExpanded) ? 'none' : '200px',
                    width: '100%',
                    overflowY: 'auto',
                    scrollbarWidth: 'none'
                }}>
                {
                    (isAvailabilityCategory ? availabilityItems : item?.items).slice(0, (!isExpanded)
                        ? 4 : item?.items.length).map((subItem, subIndex) => {
                        const subItemsLength = item?.items?.length;

                        return (
                            <li key={subIndex} className="filter-item" tabIndex={0}>
                                <label className="filter-item-label">

                                    {mapping.filterContent(
                                        item?.title,
                                        { ...subItem, title: subItem.displayTitle ?? (yesNoFromTitle(subItem.title)) },
                                        item,
                                        subItemsLength,
                                        selectedOptions,
                                        handleFilterOptionChange,
                                        handleRadioFilterOptionChange,
                                        toggleSubCategoryExpansion,
                                        expandedSubCategories,
                                        toggleCategorySelection,
                                        isCheckboxVisible,
                                        isFromListing,
                                        lang,
                                        isAvailabilityFilterSelected
                                    )}
                                    <span className={"count"}>({subItem.aggregate})</span>
                                </label>

                                {subItem?.items && subItem?.items.length > 0 && expandedSubCategories && expandedSubCategories[subItem?.title] && (
                                    <FilterSubItem
                                        subItems={subItem?.items}
                                        category={item?.title}
                                        expandedSubCategories={expandedSubCategories}
                                        toggleSubCategoryExpansion={toggleSubCategoryExpansion}
                                        toggleCategorySelection={toggleCategorySelection}
                                        selectedOptions={selectedOptions}
                                        item={item}
                                        subItem={subItem}
                                        isFromListing = {isFromListing}
                                        lang
                                    />
                                )}
                            </li>
                        );
                    })
                }
            </ul>
            <div className="c ">
                <div className="filter-category" style={{paddingBottom: '20px'}}>
                    {item?.items.length > 4 && (
                        <button className="expand-button" onClick={() => toggleCategoryExpansion(item?.title)}>
                            {lang === "en"? (isExpanded ? "Less" : "More"):( isExpanded ? "Λιγότερα" : "Περισσότερα")}
                        </button>
                    )}
                </div>
            </div>
        </div>

    );
};

export default FilterItem;
